import React from 'react';
import { useParams } from "react-router-dom";
import config from '../utils/config';

  

const FileViewer = () => {
    let { id } = useParams();

    return(
        <div style={{ width: '100%', height: '100vh', border: 'none' }}>
            <iframe
                src={`${config.backEndUrl}documents/${id}/file`}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="Document Viewer"
            />
        </div>
    )
}

export default FileViewer;